import { createDeviceTransport } from './autoTransport';
import { createNoneTransport } from './noneTransport';
import type { TerminalGateway, TerminalTransport } from './types';
import { TerminalTransportKind } from '../../../enums/terminal';

export function resolveTerminalTransportKind(
  configured: string | undefined,
): TerminalTransportKind {
  const known = Object.values(TerminalTransportKind) as string[];
  return configured && known.includes(configured)
    ? (configured as TerminalTransportKind)
    : TerminalTransportKind.AUTO;
}

export async function createTerminalTransport(
  kind: TerminalTransportKind,
  gateway: TerminalGateway,
  preferredDeviceId: string | null,
): Promise<TerminalTransport> {
  switch (kind) {
    case TerminalTransportKind.MOCK: {
      const { createMockTransport } = await import('./mockTransport');
      return createMockTransport();
    }
    case TerminalTransportKind.NONE:
      return createNoneTransport();
    default:
      return createDeviceTransport(kind, gateway, preferredDeviceId);
  }
}
